import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router";
import { useErrorModal } from "../context/ErrorModalContext";
import { useLanguage } from "../hooks/useLanguage";

const ErrorPage = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { showError } = useErrorModal();
  const { t } = useLanguage();
  const hasShownError = useRef(false);
  useEffect(() => {
    let message;

    if (state?.type === "processing") {
      message = state?.message;
    } else if (state?.type === "network") {
      message = "Network Error";
    } else if (state?.type === "session") {
      message = state?.message || "Session Timeout";
    } else if (state?.type === "internal") {
      message = "Internal Server Error";
    } else {
      message = "An error occurred. Please try again.";
    }

    if (hasShownError.current) return;
    hasShownError.current = true;

    showError({
      message: message,
      buttons: [
        {
          label: t("verification.btnExitLabel"),
          variant: "secondary",
          onClick: () => {
            navigate("/digital-onboarding");
          },
        },
      ],
    });
  }, [state, showError, t, navigate]);

  return null;
};

export default ErrorPage;
